import { sendVerificationEmail } from "@/api";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

export function useSendVerificationEmail() {
  return useMutation({
    mutationFn: async () => {
      const result = await sendVerificationEmail();
      if (result.err) {
        console.error(result.val.devMessage);
        toast.error("Error al enviar el correo de verificación", {
          description: result.val.message,
        });
        throw new Error(result.val.message);
      }

      toast.success("Correo de verificación enviado exitosamente", {
        description: result.val,
      });

      // return true to indicate that data is a truthy value
      return result.val;
    },
  });
}
